import { Grid, Theme, Typography, useMediaQuery } from '@mui/material';
import { SpecialHost } from 'api/admin/models';
import React, { useState } from 'react';
import { makeStyles } from 'tss-react/mui';
import { useModal } from 'hooks';
import Avatar from '../common/Avatar';
import EventHostModal from './EventHostModal';

interface IProps {
  eventId: number;
  specialHosts: SpecialHost[];
}

interface IStyleProps {
  many: boolean;
}

const useStyles = makeStyles<IStyleProps>()((theme, params) => ({
  item: {
    height: '100%',
    minHeight: params?.many ? 232 : 193,
    padding: theme.spacing(params?.many ? 2 : 1),
    paddingRight: params?.many ? 32 : 40,
    paddingBottom: params?.many ? 32 : 8,
    borderRadius: 8,
    background: theme.palette.background.default,
    [theme.breakpoints.down('sm')]: {
      paddingLeft: params?.many ? 18 : 10,
    },
  },
  avatar: {
    width: params?.many ? 92.5 : 96,
    height: params?.many ? 92.5 : 96,
  },
  hostName: {
    position: 'relative',
    marginTop: 2,
    minHeight: 52,
    display: '-webkit-box',
    WebkitLineClamp: '2',
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    // textOverflow: ' [..]',
    whiteSpace: 'normal',
  },
  bio: {
    position: 'relative',
    display: '-webkit-box',
    WebkitLineClamp: '3',
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    // textOverflow: ' [..]',
    whiteSpace: 'normal',
  },
}));

const EventSpecialHosts: React.FC<IProps> = (props) => {
  const { eventId, specialHosts } = props;
  const [isMany] = useState(specialHosts.length > 1);
  const { classes } = useStyles({ many: isMany });
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));
  const [showModal] = useModal(EventHostModal);

  return (
    <Grid
      container
      alignItems="stretch"
      spacing={3}
      style={{ display: 'flex', alignItems: 'stretch', flexWrap: 'wrap', gap: '24 px' }}
    >
      {specialHosts?.map((host) => {
        const handleOnClick = () => showModal({ eventId, hostId: host.id });
        return (
          <Grid
            style={
              isMobile
                ? {
                    display: 'flex',
                    flexDirection: 'row',
                    paddingLeft: 38,
                  }
                : {
                    display: 'flex',
                    flexDirection: 'column',
                    flex: '1 1 calc(50% - 24px)',
                  }
            }
            item
            xs={isMany && !isMobile ? 6 : 12}
          >
            <Grid className={classes.item} container spacing={2}>
              <Grid item className={classes.avatar}>
                <Avatar fullWidth src={host.organization_host?.image?.original_url || host.image?.original_url} />
              </Grid>
              <Grid item xs>
                <Grid container spacing={1}>
                  <Grid item xs={12} className={classes.hostName} alignContent="center">
                    <Typography
                      variant={isMany ? 'h6' : 'h5'}
                      lineHeight={isMany ? '21.6px' : '28.8px'}
                      fontWeight={isMany ? 700 : 600}
                    >
                      {host.organization_host.name}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} style={{ minHeight: 24, paddingTop: 4 }}>
                    <Typography variant="body2" fontWeight={500} lineHeight="16px">
                      {host.host_roles[0]?.name}
                    </Typography>
                  </Grid>
                  {specialHosts.length === 1 && (
                    <>
                      <Grid item xs={12} style={{ paddingTop: 0, marginTop: -8 }}>
                        <Typography
                          className={classes.bio}
                          dangerouslySetInnerHTML={{
                            __html: host.bio,
                          }}
                          variant="body2"
                          fontWeight={400}
                          lineHeight="19.5px"
                        />
                      </Grid>
                      <Grid item style={{ height: '100%', padding: 0, marginTop: 'auto', marginLeft: 'auto' }}>
                        <Typography
                          style={{
                            textAlign: 'right',
                            background: '#F5F6FA',
                            cursor: 'pointer',
                            fontSize: 13,
                            fontWeight: 500,
                            color: '#4E6DF5',
                            paddingLeft: '0.25rem',
                            lineHeight: '19.5px',
                          }}
                          onClick={handleOnClick}
                        >
                          View More
                        </Typography>
                      </Grid>
                    </>
                  )}
                </Grid>
              </Grid>
              {isMany && (
                <>
                  <Grid item xs={12} style={{ paddingTop: 0 }}>
                    <Typography
                      className={classes.bio}
                      dangerouslySetInnerHTML={{
                        __html: host.bio,
                      }}
                      variant="body2"
                      fontWeight={400}
                      lineHeight="19.5px"
                    />
                  </Grid>
                  <Grid item style={{ padding: 0, marginTop: 'auto', marginLeft: 'auto' }}>
                    <Typography
                      style={{
                        textAlign: 'right',
                        background: '#F5F6FA',
                        cursor: 'pointer',
                        fontSize: 13,
                        fontWeight: 500,
                        color: '#4E6DF5',
                        paddingLeft: '0.25rem',
                        lineHeight: '19.5px',
                      }}
                      onClick={handleOnClick}
                    >
                      View More
                    </Typography>
                  </Grid>
                </>
              )}
            </Grid>
          </Grid>
        );
      })}
    </Grid>
  );
};

export default EventSpecialHosts;
